const TEST_KEY = '__founderDna_storage_probe__';

export const isLocalStorageAvailable = () => {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  try {
    window.localStorage.setItem(TEST_KEY, '1');
    window.localStorage.removeItem(TEST_KEY);
    return true;
  } catch (e) {
    return false;
  }
};

export const safeLocalStorageGet = (key) => {
  if (!isLocalStorageAvailable()) return null;
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const safeLocalStorageSet = (key, value) => {
  if (!isLocalStorageAvailable()) return false;
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
};

export const safeLocalStorageRemove = (key) => {
  if (!isLocalStorageAvailable()) return false;
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};
